module.exports = __webpack_public_path__ + "static/media/12-6.2a5c5911.mp3";